import * as actionTypes from "../action-types";

const initialState = {
    payoutSettings: null,
    pendingPayouts: null,
    payoutHistory: null,
    payoutLoading: false,
};

const payoutReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_PAYOUT_SETTINGS:
            return { ...state, payoutSettings: payload };

        case actionTypes.GET_PENDING_PAYOUTS:
            return { ...state, payoutLoading: true };

        case actionTypes.SET_PENDING_PAYOUTS:
            return { ...state, pendingPayouts: payload, payoutLoading: false };

        case actionTypes.GET_PAYOUT_HISTORY:
            return { ...state, payoutLoading: true };

        case actionTypes.SET_PAYOUT_HISTORY:
            return { ...state, payoutHistory: payload, payoutLoading: false };

        default:
            return state;
    }
};

export default payoutReducer;
